/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        //clientId: "9a7a7ba7-9b89-49df-9fe6-a5965aa1b079",
        clientId: process.env.REACT_APP_CLIENTID,
        //authority: "https://login.microsoftonline.com/ec4a31dc-e816-4623-b8bc-dff3a2129d22",
        authority: process.env.REACT_APP_AUTHORITY,
        //redirectUri: "http://localhost:3000",
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    //case LogLevel.Info:
                    //    console.info(message);
                    //    return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

export const loginRequest = {
    // scopes: ["User.Read", "api://c792f60d-d1a3-4175-91ae-96514bcffd80/access_as_user"] :
    scopes: ["User.Read", process.env.REACT_APP_API_SCOPE]
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
//export const graphLoginRequest = {
//    scopes: ["User.Read"]
//};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
//export const graphConfig = {
//    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
//};

export const torinLoginRequest = {
    // scopes: ["api://c792f60d-d1a3-4175-91ae-96514bcffd80/access_as_user"]
    scopes: [process.env.REACT_APP_API_SCOPE]
};

export const torinConfig = {
    //torinApiEndpoint: "https://localhost:7206/api/",
    torinApiEndpoint: process.env.REACT_APP_API_URL,
};
